const API_PREFIXED_ENTRY_POINTS = [
  "file",
  "course",
  "courseLanguageVariant",
] as const;

function constructImageUrl(link: string, childrenSubjectId?: string): string {
  if (link.startsWith("http://") || link.startsWith("https://")) {
    return link;
  }

  const origin = window.location.origin;

  let url: string;

  if (
    API_PREFIXED_ENTRY_POINTS.some((entryPoint) =>
      link.startsWith(`/${entryPoint}/`)
    )
  ) {
    url = `${origin}/api/v1${link}`;
  } else if (link.startsWith("/")) {
    url = `${origin}${link}`;
  } else {
    url = `${origin}/api/v1/${link}`;
  }

  if (childrenSubjectId && childrenSubjectId !== "") {
    const separator = url.includes("?") ? "&" : "?";
    url += `${separator}impersonate_subject=${childrenSubjectId}`;
  }

  return url;
}

export function getImageUrl(
  viewLink: string,
  childrenSubjectId?: string
): string {
  return constructImageUrl(viewLink, childrenSubjectId);
}

export function getDownloadUrl(
  downloadLink: string,
  childrenSubjectId?: string
): string {
  return constructImageUrl(downloadLink, childrenSubjectId);
}
